export default {
	sec_10: {
		title: {
			one: '売却する',
		},
		desc: {
			one: '暗号資産売却が難しいですか？',
			two: 'まだ購入者をお待ちですか？',
		},
		btn: {
			one: '会員登録',
			two: 'アプリダウンロード',
		},
	},
	sec_11: {
		one: {
			title: {
				one: '暗号資産売却がとて',
				two: 'も簡易になりました。',
			},
			desc: {
				one: 'お客様間の売却お客様が直接JPWORLDPAYで販売',
				two: 'お好きな方法で売却してください。',
			},
		},
		two: {
			title: {
				one: 'ボタン一度で',
				two: '為替が自動適用',
			},
			desc: {
				one: 'ボタン一度で現在レートが自動で適用されすぐに売却が可能です。',
			},
		},
	},
};
